import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useAttrs } from 'vue';
const __default__ = {
  inheritAttrs: false
};
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ZsDialog',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isFooter: {
      type: Boolean,
      default: false
    },
    cancelText: {
      default: '取消'
    },
    confirmText: {
      default: '确定'
    },
    cancelLoading: {
      type: Boolean
    }
  },
  emits: ["cancel", "confirm"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const attrs = useAttrs();
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, _mergeProps(_unref(attrs), {
        "align-center": "",
        "append-to-body": "",
        "destroy-on-close": "",
        "close-on-click-modal": false,
        "close-on-press-escape": false
      }), _createSlots({
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 2
      }, [__props.isFooter ? {
        name: "footer",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "footer", {}, () => [_createVNode(_component_el_button, {
          loading: __props.cancelLoading,
          disabled: props.disabled,
          onClick: _cache[0] || (_cache[0] = $event => emits('cancel'))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(props.cancelText), 1)]),
          _: 1
        }, 8, ["loading", "disabled"]), _createVNode(_component_el_button, {
          type: "primary",
          loading: props.loading,
          disabled: props.disabled,
          onClick: _cache[1] || (_cache[1] = $event => emits('confirm'))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(props.confirmText), 1)]),
          _: 1
        }, 8, ["loading", "disabled"])])]),
        key: "0"
      } : undefined]), 1040);
    };
  }
});